module.exports = __webpack_public_path__ + "img/netmarble.b01f09f2.png";